import { Autocomplete, Box, IconButton, Tooltip, styled } from '@mui/material';
import useMark from '../hooks/useMark';
import { fontSizes } from '../data';
import { AddRounded, RemoveRounded } from '@mui/icons-material';
import { ReactEditor, useSlate } from 'slate-react';
import { useTranslation } from 'react-i18next';
import { Editor, Element } from 'slate';
import { headingBlocks } from '@elements';

const Input = styled('input')(({ theme }) => {
    return {
        fontSize: '0.875rem',
        backgroundColor: 'transparent',
        border: 'none',
        borderRadius: theme.shape.borderRadius,
        height: '24px',
        width: '32px',
        textAlign: 'center',
        '&::-webkit-inner-spin-button': {
            WebkitAppearance: 'none',
            margin: 0,
        },
        '&::MozAppearance': 'textfield',
        outline: `1px solid ${theme.palette.divider}`,
        flex: '1 0 auto',
        overflow: 'hidden',
        '&:hover': {
            outline: `1px solid ${theme.palette.primary.main}`,
        },
        '&:focus': {
            outline: `2px solid ${theme.palette.primary.main}`,
        },
    };
});

function FontSize() {
    const { t } = useTranslation();
    const editor = useSlate();
    const { getMark, setMark, getFallbackValue } = useMark();
    const suffix = 'px';

    const elements = Editor.nodes(editor, {
        match: n =>
            Element.isElement(n) &&
            [...headingBlocks, 'paragraph'].includes(n.type),
        universal: true,
    });

    const elementFontSize = Array.from(elements).find(
        ([element]) => element.attributes?.style?.fontSize,
    )?.[0]?.attributes?.style?.fontSize;

    const mark =
        getMark('fontSize') ||
        elementFontSize ||
        getFallbackValue('font-size') ||
        '';
    const value = mark.replace(suffix, '');

    return (
        <Box display="flex" alignItems="center">
            <Tooltip title={t('Increase Font Size')}>
                <IconButton
                    sx={{ width: '24px', height: '24px', borderRadius: '4px' }}
                    onMouseDown={e => {
                        e.preventDefault();
                        setMark('fontSize', parseInt(value) + 1 + suffix);
                    }}
                >
                    <AddRounded />
                </IconButton>
            </Tooltip>
            <Tooltip title={t('Font Size')}>
                <Autocomplete
                    freeSolo
                    options={fontSizes}
                    value={value}
                    onClose={() => ReactEditor.focus(editor)}
                    ListboxProps={{
                        sx: {
                            maxHeight: 'unset',
                            '& .MuiAutocomplete-option': {
                                justifyContent: 'center !important',
                                textAlign: 'center !important',
                            },
                        },
                    }}
                    onChange={(e, newValue) => {
                        console.log(newValue);

                        setMark('fontSize', newValue && newValue + suffix);
                    }}
                    filterOptions={options => options}
                    renderInput={params => (
                        <div ref={params.InputProps.ref}>
                            <Input
                                type="number"
                                {...params.inputProps}
                                onChange={e => {
                                    console.log(e.target.value);

                                    setMark(
                                        'fontSize',
                                        e.target.value &&
                                            e.target.value + suffix,
                                    );
                                }}
                            />
                        </div>
                    )}
                />
            </Tooltip>
            <Tooltip title={t('Decrease Font Size')}>
                <IconButton
                    sx={{ width: '24px', height: '24px', borderRadius: '4px' }}
                    onMouseDown={e => {
                        e.preventDefault();
                        setMark('fontSize', parseInt(value) - 1 + suffix);
                    }}
                >
                    <RemoveRounded />
                </IconButton>
            </Tooltip>
        </Box>
    );
}

export default FontSize;
